import { TABLE_SORT_AESC, TABLE_SORT_DESC } from './Constant';
import {
  ColumnHeaderType,
  LocationFilterInitialState,
  MapOptionType,
  SelectOptionType,
} from './Types';

export const findValueInOptions = (options: SelectOptionType[], id: any) => {
  for (const element of options) {
    if (Number(element?.value) === Number(id)) {
      return element.label;
    }
  }
  return '-';
};

export const findValueInMap = (map: MapOptionType, id: any, parentId?: any) => {
  if (!map) {
    return '-';
  }
  const array = parentId ? map[parentId] ?? [] : Object.values(map).flat();
  for (const element of array) {
    if (Number(element.value) === Number(id)) {
      return element.label;
    }
  }
  return '-';
};
/**
 * Called appropriate method to find label for table.
 * @param headerItem
 * @param item
 * @param locationData
 * @param roleOption
 * @returns
 */
export const findValueFromLocalStore = (
  headerItem: ColumnHeaderType,
  item: any,
  locationData: LocationFilterInitialState,
  roleOption: SelectOptionType[]
) => {
  const field = headerItem.field;
  const id = item[field as keyof any];

  if (field.includes('zone')) {
    return findValueInOptions(locationData?.zoneOptions, id);
  } else if (field.includes('state')) {
    return findValueInMap(locationData.statesData, id);
  } else if (field.includes('district')) {
    const stateId = item.state ?? item.stateId;
    return findValueInMap(locationData.districtData, id, stateId);
  } else if (field.includes('city')) {
    const districtId = item.district ?? item.districtId;
    return findValueInMap(locationData.cityOptions, id, districtId);
  } else if (field.includes('role')) {
    return findValueInOptions(roleOption, id);
  }
  return '-';
};
/**
 * Find label/value to display in table row.
 * @param headerItem
 * @param item
 * @param locationData
 * @param roleOption
 * @returns
 */
export const findValue = (
  headerItem: ColumnHeaderType,
  item: any,
  locationData: LocationFilterInitialState,
  roleOption: SelectOptionType[]
) => {
  if (headerItem.valueFromLocalStorage) {
    return findValueFromLocalStore(headerItem, item, locationData, roleOption);
  } else if (headerItem.valueGetter) {
    return headerItem.valueGetter(item, headerItem.field, locationData) ?? '-';
  } else if (headerItem.value) {
    return headerItem.value || '-';
  } else {
    return item[headerItem.field] || '-';
  }
};
/**
 * Sort the array for given order
 * @param field
 * @param sortBy
 * @param sortOrder
 * @param setSortOrder
 * @param setSortBy
 */
export const handleSort = (
  field: string,
  sortBy: string | null,
  sortOrder: string,
  setSortOrder: (order: string) => void,
  setSortBy: (sortByData: string) => void
) => {
  if (field === sortBy) {
    setSortOrder(
      sortOrder === TABLE_SORT_AESC ? TABLE_SORT_DESC : TABLE_SORT_AESC
    );
  } else {
    setSortBy(field);
    setSortOrder(TABLE_SORT_AESC);
  }
};
/**
 * find items on the basis of given value
 * @param headerItem
 * @param item
 * @param array
 * @returns
 */
export const findSelectValue = (
  headerItem: ColumnHeaderType,
  item: any,
  array?: SelectOptionType[]
) => {
  const value = item[headerItem.field as keyof any];
  const selectValue = array?.find(
    (item: SelectOptionType) => item.label === value
  );
  return selectValue;
};

/**
 * Sorts an array of objects based on a specified key and sort order.
 * @param data - Array of objects to be sorted.
 * @param sortBy - The key to sort the objects by.
 * @param sortOrder - The order to sort by ('asc' or 'desc').
 * @returns - Sorted array of objects.
 */
export const sortData = (
  data: any[],
  sortBy: string | null,
  sortOrder: string
) => {
  if (!sortBy) return data;
  return [...data].sort((a, b) => {
    const itemA = a[sortBy];
    const itemB = b[sortBy];
    if (itemA < itemB) return sortOrder === TABLE_SORT_AESC ? -1 : 1;
    if (itemA > itemB) return sortOrder === TABLE_SORT_AESC ? 1 : -1;
    return 0;
  });
};
